import { ScrollArea } from "@base-ui/react";
import classNames from "classnames";
import styles from "./Scrollbar.module.scss";

interface ScrollbarProps {
    children: React.ReactNode;
    className?: string;
    showFadeIndicators?: boolean;
    showTopFadeIndicator?: boolean;
    showBottomFadeIndicator?: boolean;
}

export const Scrollbar = ({
    children,
    className,
    showFadeIndicators = true,
    showTopFadeIndicator,
    showBottomFadeIndicator,
}: ScrollbarProps) => {
    const shouldShowTopFadeIndicator =
        showTopFadeIndicator ?? showFadeIndicators;
    const shouldShowBottomFadeIndicator =
        showBottomFadeIndicator ?? showFadeIndicators;

    return (
        <ScrollArea.Root className={classNames(styles.scrollArea, className)}>
            <ScrollArea.Viewport
                className={classNames(styles.viewport, {
                    [styles.viewportWithoutTopFadeIndicator]:
                        !shouldShowTopFadeIndicator,
                    [styles.viewportWithoutBottomFadeIndicator]:
                        !shouldShowBottomFadeIndicator,
                })}
            >
                <ScrollArea.Content className={styles.content}>
                    {children}
                </ScrollArea.Content>
            </ScrollArea.Viewport>
            <ScrollArea.Scrollbar className={styles.scrollbar}>
                <ScrollArea.Thumb className={styles.thumb} />
            </ScrollArea.Scrollbar>
        </ScrollArea.Root>
    );
};
